import axios from "axios";
import * as R from "ramda";
import { HEADER_AUTHORIZATION } from "consts";
import { DEFAULT_ENV, environments } from "pzEnv";

export const formatBearerAuthentication = (token: string) => `Bearer ${token}`;

type RequestOptions = {
  headers?: {
    Authorization: string;
  };
};

const defaultOptions = (token?: string) => {
  const options: RequestOptions = {};
  if (token) {
    const headerAuthorization = formatBearerAuthentication(token);
    if (headerAuthorization) {
      options.headers = { [HEADER_AUTHORIZATION]: headerAuthorization };
    }
  }
  return options;
};

export const getUri = (uri: string, env: string) => `${getHost(env)}${uri}`;

const knownHosts = Object.values(environments)
  .map(({ host }) => host)
  .filter(Boolean);

export const getHost = (env: string = "proxy") => {
  const envConfig = environments[env as keyof typeof environments];
  if (envConfig) {
    return R.prop("host")(envConfig);
  }

  if (knownHosts.includes(env)) {
    return env;
  }

  return R.prop("host")(environments[DEFAULT_ENV]);
};

export const createIAVServerClient = (env: string, ssoClient = axios) => {
  const host = getHost(env);
  
  return {
    get: (uri: string, token: string, options = {}) =>
      ssoClient
        .get(`${host}${uri}`, { ...defaultOptions(token), ...options })
        .then((res) => res.data),

    post: (uri: string, data: any, token: string, options = {}) =>
      ssoClient
        .post(`${host}${uri}`, data, { ...defaultOptions(token), ...options })
        .then((res) => res.data),
    auth: (uri: string, data: any, token: string, options = {}) =>
      ssoClient
        .post(`${host}${uri}`, data, { ...defaultOptions(token), ...options })
        .then((res) => {
          const { data, headers } = res;
          return { ...data, iavToken: headers._token };
        }),
  };
}
